// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Payment_container__Ym3w\\+ {
    display: flex;
    justify-content: left;  
    height: 100%;
    font-size: 10px;

}

.Payment_card__7l3Kp {
    display: flex;
    align-items: center;    
    justify-content: flex-start; 
    width: 100%;  
            
}

.Payment_inputRadio__-zVLx {
    margin-right: 10px; 
}

.Payment_svgIcon__amzK- {
    width: 30px;
    height: 30px;
}

.Payment_selectedOption__ycoyB {
    border: 2px solid #007bff; /* Ví dụ border khi chọn */
}
`, "",{"version":3,"sources":["webpack://./src/css/Payment.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;;AAEf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;AACzD","sourcesContent":[".container {\n    display: flex;\n    justify-content: left;  \n    height: 100%;\n    font-size: 10px;\n\n}\n\n.card {\n    display: flex;\n    align-items: center;    \n    justify-content: flex-start; \n    width: 100%;  \n            \n}\n\n.inputRadio {\n    margin-right: 10px; \n}\n\n.svgIcon {\n    width: 30px;\n    height: 30px;\n}\n\n.selectedOption {\n    border: 2px solid #007bff; /* Ví dụ border khi chọn */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Payment_container__Ym3w+`,
	"card": `Payment_card__7l3Kp`,
	"inputRadio": `Payment_inputRadio__-zVLx`,
	"svgIcon": `Payment_svgIcon__amzK-`,
	"selectedOption": `Payment_selectedOption__ycoyB`
};
export default ___CSS_LOADER_EXPORT___;
